import Box from '@material-ui/core/Box/Box';
import { styled } from '@mui/material';

const RoutesCalculationLoaderStyledContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .MuiAlert-message {
    padding-right: 20px;
  }

  .message-wrapper {
    display: flex;
    flex-direction: column;
  }

  .status-wrapper {
    display: flex;
    justify-content: space-between;
  }

  .spinner-wrapper {
    margin-right: 7px;
  }
`;

export default RoutesCalculationLoaderStyledContainer;
